import { useAppContext } from '../../../Services/AppContext';
import {
	Meta,
	useRootWorkplaceMetaByChildQuery,
} from '../../../graphql/graphql';

export default function useRootWorkplaceMeta() {
	const rootWorkplaceMeta = useRootWorkplaceMetaByChildQuery({
		workplaceId: useAppContext().workplaceId,
	});

	return {
		isLoading: rootWorkplaceMeta.isLoading,
		meta: rootWorkplaceMeta?.currentData?.workplace?.rootWorkplace
			?.meta as Meta[],
	};
}
